module.exports = __webpack_public_path__ + "static/media/8.7777de26.jpg";